export default __webpack_public_path__ + "static/media/ic_content.e2e5ed89.svg";